import React, {useEffect, useRef} from 'react';
import {DatePicker, Menu} from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import {getSnoozeOptions} from './utils';

dayjs.extend(utc);

export function SnoozeMenu(
  {
    setSnoozeTimer,
    setSnoozeDropdownVisible,
    snoozeDatePickerOpen,
    snoozeDatePickerStatus,
    setCustomSnoozeTimer,
  }
) {
  const snoozeMenu = useRef(null);

  useEffect(() => {
    const closeMenu = function (e) {
      const calendarPicker = document.querySelector('.ant-calendar-picker-container');
      if (
        !snoozeMenu.current.contains(e.target) &&
        typeof e.target.className === 'string' &&
        !e.target.className.includes('snooze_trigger') &&
        (calendarPicker ? !calendarPicker.contains(e.target) : true)
      ) {
        setSnoozeDropdownVisible(false);
      }
    };

    window.addEventListener('click', closeMenu);

    return () => {
      window.removeEventListener('click', closeMenu);
    };
  }, []);

  return (
    <div ref={snoozeMenu}>
      <Menu onClick={setSnoozeTimer}>
        {getSnoozeOptions().map(option => (
          <Menu.Item key={option.value}>
            <div>{option.label}</div>
            <div className="conversation__snooze-description">{option.description}</div>
          </Menu.Item>
        ))}
      </Menu>
      <DatePicker
        style={{
          overflow: 'hidden',
          height: 1,
          visibility: 'hidden',
          display: 'block',
          padding: 0,
        }}
        disabledDate={(current) => current && current < dayjs().endOf('day')}
        onOpenChange={snoozeDatePickerStatus}
        showNow={false}
        open={snoozeDatePickerOpen}
        onChange={setCustomSnoozeTimer}
      />
    </div>
  );
}
